import {
  Component, AfterViewInit, OnDestroy,
  Input, ChangeDetectorRef, ViewChild,
  Output, EventEmitter,
} from '@angular/core';
import { Observable ,  Subscription } from 'rxjs';
import * as _ from 'lodash';

import { AppModalService } from 'shared/modal/modal.service';
import { SubscriptionService } from 'shared/subscription/subscription.service';
import { SubscriptionWidgetComponent } from 'shared/subscription/subscription-widget/subscription-widget.component';
import {ProductPanelComponent} from '../../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'plan-info',
  templateUrl: 'plan-info.component.html',
  styleUrls: ['plan-info.component.scss'],
})

export class PlanInfoComponent implements AfterViewInit, OnDestroy {
  itemsInfo: any;
  planInfo: any;
  subscriptionInfo: any;
  nextPlanMaxCount: number;

  isSubscrFlowDisabled: boolean = false; // to disable start subscr flow
  isSubscriptionValid: boolean = false;

  @Input() brandId: string;
  @Input() timezone: string;

  @Output() subscriptionUpdated = new EventEmitter();

  @ViewChild(SubscriptionWidgetComponent, {static: false}) subscrWidget: SubscriptionWidgetComponent | void;

  getPlanItemsCountSub: Subscription;
  getPlanInfoSub: Subscription;

  constructor(
    protected subService: SubscriptionService,
    protected ref: ChangeDetectorRef,
    private appModalService: AppModalService,
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get autopayDate(): string {
    const trialEnd = _.get(this.planInfo, 'trial_ends_at');
    const end = _.get(this.planInfo, 'ends_at');
    if (!trialEnd && !end) { return null; }
    return trialEnd ? trialEnd : end;
  }

  get itemsCount(): number {
    return _.get(this.itemsInfo, 'items');
  }

  get maxItemsCount(): number {
    return _.get(this.itemsInfo, 'max_items');
  }

  get remainingItemsCount(): number {
    return _.get(this.itemsInfo, 'items_remaining');
  }

  get progressPercent(): string {
    if (!this.remainingItemsCount) { return '100%'; }
    return `${(this.itemsCount * 100) / this.maxItemsCount}%`;
  }

  get isStatusWarn(): boolean {
    const status = _.get(this.itemsInfo, 'status');
    return status === 1;
  }

  get isPlanValid(): boolean {
    const valid = _.get(this.planInfo, 'valid');
    return !!valid;
  }

  get hasHextPlan(): boolean {
    const nextPlanId = _.get(this.planInfo, 'next_upgrade');
    return nextPlanId ? nextPlanId : false;
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngAfterViewInit() {
    this.updatePlanItemsCount();
    this.updatePlanInfo();
  }

  ngOnDestroy() {
    if (this.getPlanItemsCountSub) { this.getPlanItemsCountSub.unsubscribe(); }
    if (this.getPlanInfoSub) { this.getPlanInfoSub.unsubscribe(); }
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public openPlansModal() {
    if (this.subscrWidget) {
      this.subscrWidget.openPlansModal();
    }
  }

  public openBillingModal() {
    if (this.subscrWidget) {
      this.subscrWidget.openBillingModal();
    }
  }

  public openStripeBillingUrl() {
    if (this.subscrWidget) {
      this.subscrWidget.openStripeBillingUrl();
    }
  }

  // https://speedlab.atlassian.net/browse/SPD2-2856
  // manually call flow
  public startFlow() {
    if (this.subscrWidget) {
      this.subscrWidget.startFlow(true);
    }
  }

  // manually disable flow
  public disableFlow() {
    this.isSubscrFlowDisabled = true;
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onManageBillingClick() {
    this.openStripeBillingUrl();
  }

  onUpgradePlanClick() {
    this.openPlansModal();
  }

  onSubscrUpdated() {
    this.updatePlanItemsCount();
    this.updatePlanInfo();
    this.subscriptionUpdated.emit();
  }

  onShareInvoiceClick() {
    if (this.subscrWidget) {
      this.subscrWidget.openSendBillingModal();
    }
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private updatePlanItemsCount() {
    this.getPlanItemsCountSub = this.subService.getPlanItemsCount(this.brandId)
    .subscribe((itemsInfo) => {
      this.itemsInfo = itemsInfo;
      this.ref.markForCheck();
    });
  }

  private updatePlanInfo() {
    this.getPlanInfoSub = this.subService.getSubscription(this.brandId)
    .subscribe((planInfo: any) => {
      this.planInfo = planInfo;
      this.isSubscriptionValid = _.get(this.planInfo, 'valid');
      if (this.subscrWidget) {
        // if you have no valid subscription
        if (!_.get(this.planInfo, 'valid') && !this.isSubscrFlowDisabled) {
          this.subscrWidget.openPlansModal();
        } else {
          this.subscrWidget.checkTerms();
        }
      }
      this.ref.markForCheck();
    });
  }
}
